import { useCallback, useState } from 'react';
import { TopbarStepper } from '../../../components/StepIsland/TopbarStepper';
import type { IslandStep } from '../../../components/StepIsland/StepIsland';
import '../../backlog/backlog.css';
import './dailyQc.css';
import DailyQcLogbookList from './DailyQcLogbookList';
import DailyQcHistory from './DailyQcHistory';
import type { DailyQcHistoryState } from './dailyQcFormat';

type View = { level: 'list' } | { level: 'history'; templateId: number };

/** The prototype's top-bar pill "● Data Entry — ○ Review": Daily QC's two stages, this
 *  screen being Data Entry. Shown on every level through the shared TopbarStepper. */
const STAGES: IslandStep[] = [
  { id: 'entry', label: 'Data Entry', state: 'active' },
  { id: 'review', label: 'Review', state: 'todo' },
];

/**
 * Analysis ▸ Daily QC — the lab's daily instrument / equipment checks, built from the
 * owner's prototype ALPACA_Daily_QC_Data_Entry_v1.html over G5's own tables (dbo.DailyQC +
 * the Daily QC Log Book Builder templates). List first (standing rule 10):
 *   1. active logbooks → 2. one logbook's history + trend, where New / Edit open the entry
 *      as a POPUP over the history (DailyQcEntryDialog — as the prototype, owner request).
 * The history keeps its range / search / trend field per logbook.
 */
export default function DailyQcPage({ onHome }: { onHome?: () => void }) {
  const [view, setView] = useState<View>({ level: 'list' });
  const [histState, setHistState] = useState<Record<number, DailyQcHistoryState>>({});
  const toList = useCallback(() => setView({ level: 'list' }), []);

  return (
    <>
      <TopbarStepper steps={STAGES} />
      {view.level === 'list' ? (
        <DailyQcLogbookList onHome={onHome} onOpen={(templateId) => setView({ level: 'history', templateId })} />
      ) : (
        <DailyQcHistory
          templateId={view.templateId}
          state={histState[view.templateId] ?? null}
          onState={(s) => setHistState((prev) => ({ ...prev, [view.templateId]: s }))}
          onBack={toList}
          onHome={onHome}
        />
      )}
    </>
  );
}
